import { render, staticRenderFns } from "./shiftdate.vue?vue&type=template&id=391c0bf0&scoped=true&"
import script from "./shiftdate.vue?vue&type=script&lang=js&"
export * from "./shiftdate.vue?vue&type=script&lang=js&"
import style0 from "./shiftdate.vue?vue&type=style&index=0&id=391c0bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c0bf0",
  null
  
)

export default component.exports